import React from 'react';

import { VEHICLE_STATUS } from 'store/carInstance/constants';

import { Button } from './components/Button/Button';
import { useVehicleStatusPresenter } from './VehicleStatus.presenter';
import * as S from './VehicleStatus.styles';

export const VehicleStatus = () => {
  const presenter = useVehicleStatusPresenter();

  return (
    <S.Wrapper>
      <Button
        active={presenter.status === VEHICLE_STATUS.NEW}
        disabled={presenter.disabled}
        type={VEHICLE_STATUS.NEW}
        onClick={presenter.onChange}
      />
      <Button
        active={presenter.status === VEHICLE_STATUS.OLD}
        disabled={presenter.disabled}
        type={VEHICLE_STATUS.OLD}
        onClick={presenter.onChange}
      />
    </S.Wrapper>
  );
};
